import React from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logoImage from '../../assets/img/logo-nova-1080.jpeg';
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import budgetService from "../../service/rels/relBudget";
import moment from "moment";


const PDFGenerator = ({idbudget, isValores, isPaineis}) => {

    const config = true ? {style: 'currency', currency: 'BRL'} : {minimumFractionDigits: 2};

    const openPDFInNewTab = (idbudget) => {

    const doc = new jsPDF();
    const imgWidth = 80; // Largura da imagem
    const imgHeight = 30; // Altura da imagem
    doc.addImage(logoImage, "PNG", 10, 10, imgWidth, imgHeight);


    function bufferToBase64(bufferObj) {
      const binary = bufferObj.data.reduce((acc, byte) => acc + String.fromCharCode(byte), '');
      return btoa(binary);
    }

    moment.locale('pt-br');

    budgetService.findBudgetById(idbudget).then(item => {

      console.log(item)
        
        // Adicionando o texto no header
        doc.setFontSize(10);
        doc.text("TREND MIDIA LTDA", 120, 10);
        doc.text("CNPJ: 26.294.219/0001-34", 120, 15);
        doc.text("Avenida República do Líbano,", 120, 20);
        doc.text("251 – Torre C Sala 1504", 120, 25); 
        doc.text("Pina, Recife - PE", 120, 30);
        doc.text("CEP: 51.110-160", 120, 35);
        doc.text("Exibidora: Trend Mídia", 120, 40);
    
        // Adicionando tabela dividida em duas colunas
        doc.setFontSize(12);
        doc.autoTable({
          startY: 65,
          margin: { left: 10 },
          styles: { fontSize: 10 },
          head: [["CLIENTE: " + item.customer, "AUTORIZAÇÃO Nº: " + item.autorizedNumber]],
          body: [
            ["PERÍODO: " + item.dias + " DIAS", "ATENDIMENTO: " + item.saller],
            // [": " + "", " " + ""],
            ["QUANTIDADE: " + item.qtdPaineis + (item.qtdPaineis == 1 ? " painel " : " painéis "), ""],
          ],
        });
      
        var totalItens = parseFloat(item.ticketValue) + parseFloat(item.discount);

        const foot = [];

        if (isValores) {
          foot.push([
            "VALOR TOTAL: " + parseFloat(totalItens).toLocaleString('pt-BR', config),
            "DESCONTO: " + parseFloat(item.discount).toLocaleString('pt-BR', config),
            "VALOR LÍQUIDO: " + parseFloat(item.ticketValue).toLocaleString('pt-BR', config)
          ]);
        } else {
          foot.push([
            "VALOR LÍQUIDO: " + parseFloat(item.ticketValue).toLocaleString('pt-BR', config),
            "", // coluna 2 vazia
            ""  // coluna 3 vazia
          ]);
        }

        doc.setFontSize(12);
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 15,
          margin: { left: 10 },
          head: [["Observação", " ", ""]],
          body: [[item.observation, "", ""]],
          columnStyles: {
            0: { halign: 'left' },
            1: { halign: 'center' },
            2: { halign: 'right' },
          },
          foot: foot,
          footStyles: { fontStyle: 'bold' },
        });
    
        doc.setFontSize(10);
        const faturamentoY = doc.lastAutoTable.finalY + 10;
    
        // Linha normal
        doc.setFont("helvetica", "bold");
        doc.text("Razão Social: ", 10, faturamentoY);
    
        doc.setFont("helvetica", "normal");
        doc.text(item.customer, 40, faturamentoY);
    
        // Resetando para estilo normal
        doc.setFont("helvetica", "bold");
        doc.text("CNPJ: ", 10, faturamentoY + 5);
        doc.setFont("helvetica", "normal");
        doc.text(item.cpfcnpj, 40, faturamentoY + 5);
    
        // Continuar com estilo normal
        doc.setFont("helvetica", "bold");
        doc.text("Endereço: ", 10, faturamentoY + 10);
        doc.setFont("helvetica", "normal");
        doc.text(item.address + ", " + item.number + ", " + item.neighborhood + " ", 40, faturamentoY + 10);
    
        // Repita para outros trechos onde quiser aplicar negrito.
        doc.setFont("helvetica", "bold");
        doc.text("CEP: ", 10, faturamentoY + 15);
        doc.setFont("helvetica", "normal");
        doc.text(item.cep, 40, faturamentoY + 15);
    
        doc.setFont("helvetica", "bold");
        doc.text("DADOS PARA FATURAMENTO:", 10, faturamentoY + 30);
    
    
        doc.setFont("helvetica", "bold");
        doc.text("VALOR: ", 10, faturamentoY + 40);
        doc.setFont("helvetica", "normal");
        doc.text(parseFloat(item.ticketValue).toLocaleString('pt-BR', config), 40, faturamentoY + 40);
    
    


    
        // Gerar a data atual formatada
        const currentDate = new Date();
        const formattedDate = new Intl.DateTimeFormat("pt-BR", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }).format(currentDate);


        doc.text(`Recife, ${formattedDate}`, 10, faturamentoY + 70);
        
        doc.line(10, faturamentoY + 100, 80, faturamentoY + 100);
        doc.text("Assinatura do cliente", 10, faturamentoY + 110);
      
        doc.line(120, faturamentoY + 100, 190, faturamentoY + 100);
        doc.text("Trend Mídia", 120, faturamentoY + 110);


    
        if (isPaineis) {
          const paineisPorPagina = 4;
          const totalPaineis = item.paineis.length;
          const totalPaginas = Math.ceil(totalPaineis / paineisPorPagina);
        
          let painelIndex = 0;
        
          for (let pagina = 0; pagina < totalPaginas; pagina++) {
            doc.addPage();
        
            // Cabeçalho
            doc.addImage(logoImage, "PNG", 10, 10, imgWidth, imgHeight);
            doc.setFontSize(10);
            doc.text("TREND MIDIA LTDA", 120, 10);
            doc.text("CNPJ: 26.294.219/0001-34", 120, 15);
            doc.text("Avenida República do Líbano,", 120, 20);
            doc.text("251 – Torre C Sala 1504", 120, 25);
            doc.text("Pina, Recife - PE", 120, 30);
            doc.text("CEP: 51.110-160", 120, 35);
            doc.text("Exibidora: Trend Mídia", 120, 40);
            doc.setFont("helvetica", "normal");
        
            let currentY = 70;
        
            for (let i = 0; i < paineisPorPagina && painelIndex < totalPaineis; i++) {
              const painel = item.paineis[painelIndex++];

              if(painel?.photo) {
                const base64String = bufferToBase64(painel?.photo);
                const imageData = `data:image/jpeg;base64,${base64String}`;
  
                doc.addImage(
                  imageData || "https://placehold.co/300x200?text=Imagem+indispon%C3%ADvel&font=roboto",
                  "JPEG",
                  5,
                  currentY,
                  40,
                  35
                );
              } else {

                doc.addImage(
                  "" || "https://placehold.co/300x200?text=Imagem+indispon%C3%ADvel&font=roboto",
                  "JPEG",
                  5,
                  currentY,
                  45,
                  40
                );

              }
        
              doc.setFont("helvetica", "bold");
              doc.text("Descrição: " + painel.name + " - Tipo: " + painel.type, 55, currentY + 5);
              // doc.setFont("helvetica", "normal"); 
              // doc.text(painel.name || "-", 55, currentY + 10);
        
              doc.setFont("helvetica", "bold");
              doc.text("Endereço:", 55, currentY + 10);

              doc.setFont("helvetica", "normal");
              const fullAddress = `${painel?.address?.address || ""}, ${painel?.address?.number || ""}, ${painel?.address?.neighborhood || ""}, ${painel?.address?.city || ""} - ${painel?.address?.state || ""}, CEP: ${painel?.address?.cep || ""}`;
              doc.text(doc.splitTextToSize(fullAddress, 130), 55, currentY + 15);

              doc.setFont("helvetica", "bold");
              doc.text("Referencia:" + `Latitude: ${painel.latitude || ""} - Longitude: ${painel.longitude || ""}`, 55, currentY + 25);

              doc.setFont("helvetica", "bold");
              doc.text("Formato :" + `${painel.describeFormat || ""}`, 55, currentY + 30);

              // const reference2 = `Latitude: ${painel.latitude || ""} - Longitude: ${painel.longitude || ""}`;
              // const linkText = doc.splitTextToSize(reference2, 160);
              // doc.text(linkText, 55, currentY + 35);
              
              // Cria o link (substitua com as coordenadas reais se necessário)
              // const latitude = painel.latitude || "0";
              // const longitude = painel.longitude || "0";
              // const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
              
              // // Adiciona o link sobre o texto
              // doc.link(55, currentY + 35, 100, 5, { url: googleMapsUrl });

              const latitude2 = painel.latitude || "0";
              const longitude2 = painel.longitude || "0";
              const googleMapsUrl2 = `https://www.google.com/maps?q=${latitude2},${longitude2}`;
              doc.setTextColor(0, 0, 255);
              const reference3 = `Localização no Google Maps, Clique Aqui!`;
              const linkText3 = doc.splitTextToSize(reference3, 160);
              // doc.textWithLink(linkText3, 55, currentY + 40);
              doc.textWithLink(reference3, 55, currentY + 35, { url: googleMapsUrl2 });
              doc.setTextColor(0, 0, 0);
              // Cria o link (substitua com as coordenadas reais se necessário)
              
              // Adiciona o link sobre o texto
              doc.link(55, currentY + 40, 100, 5, { url: googleMapsUrl2 });

              

              currentY += 50;
            }
          }
         
          
          // // Adicionar página final com assinatura
          // doc.addPage();
          // doc.setFont("helvetica", "normal");
          // doc.setFontSize(10);
        

          // doc.addImage(logoImage, "PNG", 10, 10, imgWidth, imgHeight);
          // doc.setFontSize(10);
          // doc.text("TREND MIDIA LTDA", 120, 10);
          // doc.text("CNPJ: 26.294.219/0001-34", 120, 15);
          // doc.text("Avenida República do Líbano,", 120, 20);
          // doc.text("251 – Torre C Sala 1504", 120, 25);
          // doc.text("Pina, Recife - PE", 120, 30);
          // doc.text("CEP: 51.110-160", 120, 35);
          // doc.text("Exibidora: Trend Mídia", 120, 40);
          // doc.setFont("helvetica", "normal");

          // const currentDate = new Date();
          // const formattedDate = new Intl.DateTimeFormat("pt-BR", {
          //   day: "numeric",
          //   month: "long",
          //   year: "numeric",
          // }).format(currentDate);
        
         
        }
        
        // Adicionar a data ao PDF
        // doc.text(`Recife, ${formattedDate}`, 10, faturamentoY + 80);
    
        // // Adicionando assinatura
        // const signatureY = faturamentoY + 100;
        // doc.line(10, signatureY, 80, signatureY); // Linha para assinatura do cliente
        // doc.text("Assinatura do cliente", 10, signatureY + 5);
    
        // doc.line(120, signatureY, 190, signatureY); // Linha para assinatura da TrendMídia
        // doc.text("Trend Mídia", 120, signatureY + 5);


        // Abrir em uma nova aba
        const pdfBlob = doc.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, "_blank");

    }).catch(error => {
        console.log(error)
    });


  };

  return (
    <div style={{textAlign: "center" }}>
      
            <Button
                onClick={e=> {openPDFInNewTab(idbudget)}}
                style={{ background: 'black', color: '#FFF' }}
                // sx={{ mr: 1 }}
            >
                <PrinterOutlined /> Imprimir
            </Button>
    </div>
  );
};

export default PDFGenerator;